var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.displayConfig
                ? _c("web-service-configuration-form", {
                    attrs: {
                      readonly: !_vm.editMode,
                      mode: _vm.mode,
                      tb: _vm.tb,
                      CertificatServer: _vm.CertificatServer,
                      CAServer: _vm.CAServer,
                    },
                    model: {
                      value: _vm.config,
                      callback: function ($$v) {
                        _vm.config = $$v
                      },
                      expression: "config",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _vm.mode === "create" && _vm.demo
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "primary",
                },
                on: { click: _vm.createConfig },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" &&
          _vm.editMode === false &&
          _vm.canEditConfig &&
          _vm.demo
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("administration.edit"),
                  icon: "fa-light fa-pencil",
                  variant: "primary",
                },
                on: { click: _vm.editModeActivate },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" &&
          _vm.editMode === false &&
          _vm.canDeleteConfig &&
          _vm.demo
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("rights.delete"),
                  icon: "fa-light fa-trash",
                  variant: "danger",
                },
                on: { click: _vm.deleteConfig },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "details" && _vm.editMode === true && _vm.demo
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "primary",
                },
                on: { click: _vm.editConfig },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }